import React from "react"

import logo from '../assets/image/pjm_logo_blue.png'

const Logo = () => {
  return(
    <div>
      <img src={logo} alt="PJM" />
    </div>
  )
}

export default Logo